import React from 'react';

import useCategoryActions from '../../hooks/useCategoryActions';
import { CategoryLayoutView, CategoryType } from '../../types';
import CategoryItem from '../CategoryItem';
import type { DraggingItemType, OnDragContentArgs } from '../CategoryList/types';

interface CategoryTreeProps {
  categoryTrees?: CategoryType[] | null;
  layoutView: CategoryLayoutView;
  level: number;
  actions: ReturnType<typeof useCategoryActions>['actions'];
  state: ReturnType<typeof useCategoryActions>['state'];
  parentCategory?: CategoryType;
  isMoving?: boolean;
  draggingItem: React.MutableRefObject<DraggingItemType | undefined>;
  onDrop: (args: OnDragContentArgs) => void;
  hierarchyPath: string[];
}

const CategoryTree = ({
  categoryTrees,
  layoutView,
  level,
  actions,
  state,
  parentCategory,
  isMoving,
  draggingItem,
  onDrop,
  hierarchyPath,
}: CategoryTreeProps) => {
  // will traverse through root category and child categories
  if (!categoryTrees?.length) {
    return null;
  }

  return (
    <>
      {categoryTrees.map((category, index) => (
        <CategoryItem
          key={category.id}
          actions={actions}
          category={category}
          draggingItem={draggingItem}
          hierarchyPath={hierarchyPath}
          index={index}
          isMoving={isMoving}
          layoutView={layoutView}
          level={level}
          parentCategory={parentCategory}
          state={state}
          onDrop={onDrop}
        />
      ))}
    </>
  );
};

export default CategoryTree;
